import * as React from 'react';
import {
  List,
  Datagrid,
  DateField,
  TextField,
  ListProps,
  SelectInput,
  Identifier,
} from 'react-admin';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';

import { showDetails } from '../config';

import { UuidField } from '../components/fields';
import { DefaultPagination } from '../components/pagination';

export const ParticipantIcon = DirectionsRunIcon;

const participantFilters = [
  <SelectInput
    key="show_id"
    label="Show ID"
    source="show_id"
    parse={(value) => (value === '' ? undefined : value)}
    choices={showDetails.map((show) => ({
      id: show.show_id,
      name: show.show_id,
    }))}
  />,
];

export const ParticipantList: React.FC<ListProps> = (props) => {
  const handleRowClick = (id: Identifier, resource: string, record: any) => {
    // Navigate to events page with participant_id filter
    const participantId = String(record.id);
    const filter = encodeURIComponent(JSON.stringify({ participant_id: participantId }));
    const displayedFilters = encodeURIComponent(JSON.stringify({ participant_id: true }));
    return `/event?displayedFilters=${displayedFilters}&filter=${filter}&order=DESC&page=1&perPage=50&sort=occurred_at`;
  };

  return (
    <List
      {...props}
      perPage={25}
      pagination={<DefaultPagination />}
      exporter={false}
      sort={{ field: 'created_at', order: 'DESC' }}
      filters={participantFilters}
    >
      <Datagrid rowClick={handleRowClick}>
        <TextField source="show_id" />
        <UuidField source="id" />
        <TextField source="name" />
        <DateField source="created_at" showTime={true} locales={['en-GB']} />
      </Datagrid>
    </List>
  );
};
